import { FC } from 'react';
import { Route } from 'react-router-dom';

import { routesSettings } from 'constants/routes';
import { withMotion } from 'utils';

// IMPORT ROUTE
import ForgotPassword from 'routes/auth/ForgotPassword';
import ResetPassword from 'routes/auth/ResetPassword';
import Faq from 'routes/main/Faq';
import Home from 'routes/main/Home';
import PrivacyPolicy from 'routes/main/PrivacyPolicy';
import Rent from 'routes/main/Rent';
import RentalProduct from 'routes/main/RentalProduct';
import TermsAndConditions from 'routes/main/TermsAndConditions';
import ProductDetails from 'routes/public/ProductDetails';

export const publicRouteConfig = {
  // AUTH ROUTE ENTRY
  AUTH_PRODUCT_DETAILS: {
    component: ProductDetails,
    path: routesSettings.AUTH_PRODUCT_DETAILS.path,
  },
  AUTH_FORGOT_PASSWORD: {
    component: ForgotPassword,
    path: routesSettings.AUTH_FORGOT_PASSWORD.path,
  },
  AUTH_RESET_PASSWORD: {
    component: ResetPassword,
    path: routesSettings.AUTH_RESET_PASSWORD.path,
  },

  PUBLIC_RENT: {
    component: Rent,
    path: routesSettings.RENT.path,
  },

  PUBLIC_RENT_PRODUCT: {
    component: RentalProduct,
    path: routesSettings.MAIN_RENT_PRODUCT.path,
  },

  PUBLIC_HOME: {
    component: Home,
    path: routesSettings.HOME.path,
  },

  PUBLIC_FAQ: {
    component: Faq,
    path: routesSettings.PUBLIC_FAQ.path,
  },

  PUBLIC_TERMS_AND_CONDITIONS: {
    component: TermsAndConditions,
    path: routesSettings.PUBLIC_TERMS_AND_CONDITIONS.path,
  },

  PUBLIC_PRIVACY_POLICY: {
    component: PrivacyPolicy,
    path: routesSettings.PUBLIC_PRIVACY_POLICY.path,
  },
} as const;

const PublicRoutes = () => {
  return Object.values(publicRouteConfig).map((route, index) => {
    return (
      <Route
        key={route.path + index}
        path={route.path}
        Component={withMotion(route.component) as FC}
      />
    );
  });
};

export default PublicRoutes;
